<si-form-item [label]="label() | translate" [formErrorMapper]="finalErrorMapper()" [required]="isRequired()">
    <textarea
        [id]="formControlName() + 'Control'"
        [class]="textareaClasses()"
        [placeholder]="placeholder() | translate"
        [formControl]="control"
        [readOnly]="readonly()"
        [attr.aria-required]="isRequired() ? 'true' : null"
    ></textarea>
</si-form-item>
